import { render, staticRenderFns } from "./CategoriesNavbarSidebar.vue?vue&type=template&id=07f71c3d"
import script from "./CategoriesNavbarSidebar.vue?vue&type=script&lang=js"
export * from "./CategoriesNavbarSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports